// exportToCsv.js
export function exportToCsv(data, fileName) {
  // UTF-8的BOM
  let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
  let csvContent = ""; // 从空字符串开始构建CSV内容
  // 添加标题行
  const headers = Object.keys(data[0]);
  csvContent += headers.join(",") + "\r\n"; // 确保在标题行后添加换行符
  // 添加数据行
  data.forEach(row => {
    let rowData = headers.map(header => {
      let escaped = ('' + row[header]).replace(/"/g, '\\"'); // 处理引号
      return `"${escaped}"`; // 确保任何内容都被引号包围
    }).join(",");
    csvContent += rowData + "\r\n"; // 确保在数据行后添加换行符
  });
  // 合并BOM和CSV内容
  const blob = new Blob([bom, csvContent], { type: 'text/csv;charset=utf-8;' });
  const csvData = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", csvData);
  link.setAttribute("download", fileName); // CSV文件名
  document.body.appendChild(link); // 必要的步骤，添加到DOM中才能触发下载
  link.click(); // 触发下载
  document.body.removeChild(link); // 下载完成后移除元素
}